import { makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
import { IUser } from '../types/User';
import { UserService } from '../services';

export default class UserStore {
    validUsersList: IUser[] = [];

    invalidUsersList: IUser[] = [];

    userListLoading: boolean = false;

    error: any;

    private userService: typeof UserService;

    constructor() {
        this.userService = UserService;
        makeAutoObservable(this);
    }

    private pushValidNewUsers(users: IUser[]): void {
        users.forEach((user) => this.validUsersList.push(user));
    }

    private pushInvalidNewUsers(users: IUser[]): void {
        users.forEach((user) => this.invalidUsersList.push(user));
    }

    private setUserListLoading(value: boolean): void {
        this.userListLoading = value;
    }

    private setError(error: any): void {
        // eslint-disable-next-line no-console
        console.error(error);
        this.error = error;
        toast.error(error.message);
    }

    async fetchValidUsers(
        skipSessions: number,
        limit: number,
    ): Promise<IUser[]> {
        try {
            this.setUserListLoading(true);
            const users: IUser[] = await this.userService.fetchValidUsers(
                skipSessions,
                limit,
            );
            this.pushValidNewUsers(users);
            this.setUserListLoading(false);
            return users;
        } catch (error) {
            this.setUserListLoading(false);
            this.setError(error);
            return [];
        }
    }

    async fetchInvalidUsers(
        skipSessions: number,
        limit: number,
    ): Promise<IUser[]> {
        try {
            this.setUserListLoading(true);
            const users: IUser[] = await this.userService.fetchInvalidUsers(
                skipSessions,
                limit,
            );
            this.pushInvalidNewUsers(users);
            this.setUserListLoading(false);
            return users;
        } catch (error) {
            this.setUserListLoading(false);
            this.setError(error);
            return [];
        }
    }
}
